export const loadReadNotificationsCache = () => {
	const cachedOrders = localStorage.getItem('readOrdersCache');
	return cachedOrders ? JSON.parse(cachedOrders) : {};
};

export const saveReadNotificationsCache = (cache) => {
	localStorage.setItem('readOrdersCache', JSON.stringify(cache));
};

export const removeNotificationsFromCache = () => {
	localStorage.removeItem('readOrdersCache');
	//TODO IDENTIFICAR EL TYPE_ID PARA ELIMINAR LA NOTIFICACIÓN CORRESPONDIENTE Y NO TODAS
};
